import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import API_BASE_URL from '../../config/api';
import styles from './BankDetailsForm.module.scss';

const BankSurvey = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    office_name: '',
    accountant_name: '',
    official_email: '',
    bank_accounts: [
      { bank_name: '', account_type: '', account_number: '' },
      { bank_name: '', account_type: '', account_number: '' },
      { bank_name: '', account_type: '', account_number: '' },
      { bank_name: '', account_type: '', account_number: '' },
      { bank_name: '', account_type: '', account_number: '' },
      { bank_name: '', account_type: '', account_number: '' }
    ]
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleClose = () => {
    // Check if user has entered any data
    const hasData = formData.office_name.trim() || 
                   formData.accountant_name.trim() || 
                   formData.official_email.trim() ||
                   formData.bank_accounts.some(account => 
                     account.bank_name.trim() || 
                     account.account_type.trim() || 
                     account.account_number.trim()
                   );

    if (hasData && !success) {
      const confirmClose = window.confirm('तपाईंले भर्नुभएको डाटा हराउन सक्छ। के तपाईं निश्चित हुनुहुन्छ?');
      if (!confirmClose) {
        return;
      }
    }
    
    navigate('/mu-central-office');
  };

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleBankAccountChange = (index, field, value) => {
    setFormData(prev => ({
      ...prev,
      bank_accounts: prev.bank_accounts.map((account, i) => 
        i === index ? { ...account, [field]: value } : account
      )
    }));
  };

  const addNewBankAccount = () => {
    setFormData(prev => ({
      ...prev,
      bank_accounts: [...prev.bank_accounts, { bank_name: '', account_type: '', account_number: '' }]
    }));
  };

  const removeBankAccount = (index) => {
    if (formData.bank_accounts.length > 1) {
      setFormData(prev => ({
        ...prev,
        bank_accounts: prev.bank_accounts.filter((_, i) => i !== index)
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      // Filter out empty bank accounts
      const validBankAccounts = formData.bank_accounts.filter(
        account => account.bank_name.trim() || account.account_type.trim() || account.account_number.trim()
      );

      if (validBankAccounts.length === 0) {
        setError('कृपया कम्तिमा एउटा बैंक खाताको विवरण भर्नुहोस्।');
        setLoading(false);
        return;
      }

      // Create the group data
      const groupData = {
        office_name: formData.office_name,
        account_head_name: formData.accountant_name,
        official_email: formData.official_email,
        bank_accounts: validBankAccounts,
        created_by: 'User'
      };

      // Use bulk create endpoint to create all bank accounts as one group
      const response = await fetch(`${API_BASE_URL}/api/bank-details/bulk_create_group/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(groupData)
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.error || 'Failed to create bank details');
      }

      // Show success message with token and instructions
      const successMessage = `
        <div style="text-align: center; padding: 20px;">
          <h3 style="color: #28a745; margin-bottom: 15px;">✅ बैंक विवरण सफलतापूर्वक सुरक्षित गरियो!</h3>
          <div style="background: #f8f9fa; border: 2px solid #28a745; border-radius: 8px; padding: 20px; margin: 15px 0;">
            <h4 style="margin-bottom: 10px;">आफ्नो टोकन:</h4>
            <div style="font-size: 18px; font-weight: bold; color: #007bff; margin-bottom: 15px;">
              ${result.reference_code}
            </div>
            <p style="margin-bottom: 10px;"><strong>⚠️ महत्वपूर्ण:</strong></p>
            <ul style="text-align: left; margin: 0; padding-left: 20px;">
              <li>यो टोकन सुरक्षित राख्नुहोस्</li>
              <li>भविष्यमा सम्पादनको लागि यो टोकन चाहिन्छ</li>
              <li><strong>एडमिनलाई यो टोकन सक्रिय गर्न भन्नुहोस् (सम्पादनको लागि आवश्यक)</strong></li>
              <li>सम्पादनको लागि: <a href="/tokenedit?token=${result.reference_code}" style="color: #007bff;">यहाँ क्लिक गर्नुहोस्</a></li>
            </ul>
            <div style="background: #fff3cd; border: 1px solid #ffeaa7; border-radius: 5px; padding: 10px; margin-top: 15px;">
              <p style="margin: 0; color: #856404;"><strong>नोट:</strong> टोकन सक्रिय नभएसम्म सम्पादन गर्न मिल्दैन। एडमिनले टोकन सक्रिय गर्नुपर्छ।</p>
            </div>
          </div>
        </div>
      `;
      
      setSuccess(successMessage);

      // Reset form
      setFormData({
        office_name: '',
        accountant_name: '',
        official_email: '',
        bank_accounts: [
          { bank_name: '', account_type: '', account_number: '' },
          { bank_name: '', account_type: '', account_number: '' },
          { bank_name: '', account_type: '', account_number: '' },
          { bank_name: '', account_type: '', account_number: '' },
          { bank_name: '', account_type: '', account_number: '' },
          { bank_name: '', account_type: '', account_number: '' }
        ]
      });

    } catch (err) {
      setError(err.message || 'Failed to create bank details');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.modalOverlay} style={{ position: 'static', backgroundColor: 'transparent' }}>
      <div className={styles.modal} style={{ maxWidth: '1200px', margin: '20px auto' }}>
        <div className={styles.modalHeader}>
          <h2>बैंक खाता विवरण फारम</h2>
          <button
            type="button"
            onClick={handleClose}
            className={styles.closeButton}
            title="फारम बन्द गर्नुहोस्"
          >
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit} className={styles.form}>
          <div className={styles.tableContainer}>
            <table className={styles.formTable}>
              <tbody>
                <tr>
                  <th colSpan="4" className={styles.centerHeader}>
                    मध्यपश्चिम विश्वविद्यालय
                  </th>
                </tr>
                <tr>
                  <td>कार्यालयको नाम.-</td>
                  <td colSpan="3">
                    <input
                      type="text"
                      value={formData.office_name}
                      onChange={(e) => handleInputChange('office_name', e.target.value)}
                      placeholder="कार्यालयको नाम भर्नुहोस्"
                      required
                    />
                  </td>
                </tr>
                <tr>
                  <td>लेखा प्रमुखको नाम</td>
                  <td colSpan="3">
                    <input
                      type="text"
                      value={formData.accountant_name}
                      onChange={(e) => handleInputChange('accountant_name', e.target.value)}
                      placeholder="लेखा प्रमुखको नाम भर्नुहोस्"
                      required
                    />
                  </td>
                </tr>
                <tr>
                  <td>लेखा प्रमुखको <b>official Mail ID</b></td>
                  <td colSpan="3">
                    <input
                      type="email"
                      value={formData.official_email}
                      onChange={(e) => handleInputChange('official_email', e.target.value)}
                      placeholder="official email भर्नुहोस्"
                      required
                    />
                  </td>
                </tr>
                <tr>
                  <th colSpan="4" className={styles.centerHeader}>
                    कार्यालयको नाममा सञ्चालित सम्पूर्ण बैक खाताको विवरण
                  </th>
                </tr>
                <tr>
                                          <th>क्र.सं.</th>
                        <th>बैंक नाम</th>
                  <th>खाताको प्रकार</th>
                  <th>खाता नं.</th>
                </tr>
                {formData.bank_accounts.map((account, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>
                      <input
                        type="text"
                        value={account.bank_name}
                        onChange={(e) => handleBankAccountChange(index, 'bank_name', e.target.value)}
                        placeholder="बैंकको नाम"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        value={account.account_type}
                        onChange={(e) => handleBankAccountChange(index, 'account_type', e.target.value)}
                        placeholder="खाताको प्रकार"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        value={account.account_number}
                        onChange={(e) => handleBankAccountChange(index, 'account_number', e.target.value)}
                        placeholder="खाता नंबर"
                      />
                    </td>
                    {formData.bank_accounts.length > 1 && (
                      <td>
                        <button
                          type="button"
                          onClick={() => removeBankAccount(index)}
                          className={styles.removeButton}
                          title="यो पङ्क्ति हटाउनुहोस्"
                        >
                          ×
                        </button>
                      </td>
                    )}
                  </tr>
                ))}
                <tr>
                  <td colSpan="4" className={styles.addRowCell}>
                    <button
                      type="button"
                      onClick={addNewBankAccount}
                      className={styles.addRowButton}
                    >
                      + नयाँ पङ्क्ति थप्नुहोस्
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className={styles.note}>
            <p><b>नोट:-</b> सम्पूर्ण नमस्कार, माथि उल्लेखित विवरण अनिवार्यरुपमा भर्नुहोस् जानकारी गराइन्छ ।</p>
          </div>

          {error && <div className={styles.error}>{error}</div>}
          {success && <div className={styles.success} dangerouslySetInnerHTML={{ __html: success }}></div>}

          <div className={styles.formActions}>
            <button
              type="button"
              onClick={handleClose}
              className={styles.cancelButton}
              disabled={loading}
            >
              रद्द गर्नुहोस्
            </button>
            <button
              type="submit"
              className={styles.submitButton}
              disabled={loading}
            >
              {loading ? 'सुरक्षित गर्दै...' : 'सुरक्षित गर्नुहोस्'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default BankSurvey;
